import cloneDeep from 'lodash/cloneDeep';
import {useEffect, useState} from 'react';

export function useCarouselBreakpoint(breakpoints?: number[]) {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    if (!breakpoints || breakpoints.length === 0) {
      return;
    }
    // break point 오름차순으로 정리
    const sortedBreakpoints = cloneDeep(breakpoints).sort((a, b) => a - b);
    const mediaQueryLists = sortedBreakpoints.map((breakPoint, idx) => {
      const nextBreakpoint = sortedBreakpoints[idx + 1];
      const query = `(min-width: ${breakPoint}px)${
        nextBreakpoint ? ` and (max-width: ${nextBreakpoint - 1}px)` : ''
      }`;
      return window.matchMedia(query);
    });

    function mediaQueryListEventHanlder(e: MediaQueryListEvent) {
      if (e.matches) {
        const foundIndex = mediaQueryLists.findIndex(
          mediaQueryList => mediaQueryList.media === e.media
        );
        setCurrentBreakpoint(sortedBreakpoints[foundIndex]);
      }
    }

    function initializeBreakpoint(e: MediaQueryListEvent) {
      if (e.matches) {
        setCurrentBreakpoint(undefined);
      }
    }
    // 주입된 최소 breakpoint에도 해당하지 않는 경우 (ex. 360이 최소값인데 viewport가 360아래인 경우)
    const defaultMediaQueryList = window.matchMedia(
      `(max-width: ${sortedBreakpoints[0]}px)`
    );
    defaultMediaQueryList.addEventListener
      ? defaultMediaQueryList.addEventListener('change', initializeBreakpoint)
      : defaultMediaQueryList.addListener(initializeBreakpoint);

    mediaQueryLists.forEach((mediaQueryList, idx) => {
      if (mediaQueryList.matches) {
        setCurrentBreakpoint(sortedBreakpoints[idx]);
      }
      // 낮은버전 사파리 등에서는 addEventListner를 지원하지 않음.그래서 deprecate된 addListner를 사용한다 (remove도 마찬가지로 removeListner를 사용함 )
      mediaQueryList.addEventListener
        ? mediaQueryList.addEventListener('change', mediaQueryListEventHanlder)
        : mediaQueryList.addListener(mediaQueryListEventHanlder);
    });
    return () => {
      mediaQueryLists.forEach(mediaQueryList =>
        mediaQueryList.removeEventListener
          ? mediaQueryList.removeEventListener(
              'change',
              mediaQueryListEventHanlder
            )
          : mediaQueryList.removeListener(mediaQueryListEventHanlder)
      );
      defaultMediaQueryList.removeEventListener
        ? defaultMediaQueryList.removeEventListener(
            'change',
            initializeBreakpoint
          )
        : defaultMediaQueryList.removeListener(initializeBreakpoint);
    };
  }, [breakpoints]);
  return currentBreakpoint;
}
